/* eslint-disable */

// import { mockTestSessions, mockAssessmentSets, mock1AssessmentSets, mockNewSession } from "../_mocks";
const { mockTestSessions, mockAssessmentSets, mock1AssessmentSets, mockNewSession } = {} as {
  mockTestSessions: any
  mockAssessmentSets: any[]
  mock1AssessmentSets: any[]
  mockNewSession: any
}

const mockCognitoId = process.env.REACT_APP_MOCK_COGNITO_USER
const mockNetwork = parseInt(process.env.REACT_APP_MOCK_NETWORK || '1000')

let scopedMockTestSessions = mockTestSessions as any[] // we can push to this

export const sleep = async (ms: number = mockNetwork) =>
  new Promise((res) => setTimeout(res, ms))

export const mockAPI = {
  get: async (_: any, url: string, options: any) => {
    await sleep()

    let data;
    if (url.includes("/items/testsets") && url.includes("sessions")) {
      data = scopedMockTestSessions.filter(session => {
        return url === `/items/testsets/${session.assessmentSetID}/sessions`
      })

    } else if (url.includes("/items/testsets/")) {
      data = mock1AssessmentSets.filter((set) => {
        return url === `/items/testsets/${set.ID}`
      })

    } else if (url.includes("/items/testsets")) {
      data = mockAssessmentSets

    } else if (url.includes("curriculum/completionstatus")) {
      data = getMocks.curriculumCompletionstatus;
    } else if (url.includes("tests")) {
      data = getMocks.getTests;
    } else if (url.includes("next")) {
      data = getMocks.questionNext as any;
    } else if (url.includes("sessions/") && url.includes("questions")) {
      data = getMocks.sessionQuestions;
    } else {
      console.log("didn't match url", url);
      return null;
    }
    console.log(`mocking API GET for ${url}`, { data });

    return data;
  },
  post: async (_: any, url: string, options: any) => {
    await sleep(2000)

    let data

    if (url.includes("/items/testsets/") && url.includes("/sessions")) {
      data = mockNewSession()
      scopedMockTestSessions.push(data)
    } else {
      console.log("didn't match url", url);
      return null;
    }
    console.log(`mocking API POST for ${url}`, { data });

    return data
  },
};

export const getMocks = {
  testsets: [
    {
      ID: 0,
      title: "First Mock Assessment",
      ID_cognito: mockCognitoId,
      firstname: "idea-presentations",
      lastname: "Boss",
    },
    {
      ID: 1,
      title: "Second Mock Assessment",
      ID_cognito: mockCognitoId,
      firstname: "idea-presentations",
      lastname: "Boss",
    },
  ],
  curriculumCompletionstatus: {
    completedLessons: 0,
    totalLessons: 37,
    hasCompletedSelfStudyCurriculum: 1,
  },
  sessionQuestions: [
    {
      id: 1012,
      progress: 0,
      caption_short: "Diagnosis of Oral Hairy Leukoplakia",
    },
    {
      id: 1787,
      progress: 0,
      caption_short: "Angular Cheilitis",
    },
    {
      id: 1029,
      progress: 0,
      caption_short: "Therapy for Molluscum Contagiosum",
    },
    {
      // id: 1011,
      id: 0,
      progress: 0,
      caption_short: "Treatment of Oral Candidiasis",
    },
    {
      // id: 1783,
      id: 0,
      progress: 0,
      caption_short: "Histoplasmosis",
    },
  ],
  getTests: [
    {
      ID: 48,
      title: "2014 Pre-Test",
      new_ID: 0,
      old_ID: 0,
      question_bank: -1,
      description: "",
      auto_assign: 0,
      time_limit: 3600,
      availability_window: 0,
      availability_start_date: "0000-00-00 00:00:00",
      resumes: 2,
      attempts: 1,
      attempt_delay: 604800,
      minimum_score: 80,
      status: 1,
      created: "2014-04-04 22:36:27",
      last_updated: "2015-06-02 21:58:06",
      original_ID: 0,
      questions: 2248,
    },
  ],
  questionNext: {
    ID: 1031,
    caption_short: "Treatment of Disseminated Kaposi's Sarcoma",
    caption:
      "Which one of the following would be the most appropriate treatment for the man with disseminated Kaposi&rsquo;s sarcoma?",
    background:
      "A 24-year-old man presents with multiple violaceous papular lesions on his chest and arms and is diagnosed with Kaposi&rsquo;s sarcoma. An HIV-1/2 antigen-antibody test is performed and confirms that he has HIV. An initial CD4 count is 86 cells/mm<sup>3</sup> and initial HIV RNA level is 87,865 copies/mL. He also has symptoms of cough and multiple scattered pulmonary lesions. A bronchoscopy with biopsy is performed and shows endobronchial&nbsp;Kaposi&rsquo;s sarcoma. He is started on oral trimethoprim-sulfamethoxazole and immediately referred to an oncologist for optimal management of the Kaposi&rsquo;s sarcoma.&nbsp;",
    type: "single",
    date_started: "2020-12-02 13:37:09",
    initial_call: 1,
    related_level4_ID: 677,
    options: [
      {
        ID: 5091,
        number: 1,
        name: "",
        value: "",
        explain: 0,
        caption: "Start antiretroviral therapy plus cytotoxic chemotherapy",
      },
      {
        ID: 5092,
        number: 2,
        name: "",
        value: "",
        explain: 0,
        caption:
          "Start high-dose corticosteroids and defer antiretroviral therapy for 8 weeks",
      },
      {
        ID: 5093,
        number: 3,
        name: "",
        value: "",
        explain: 0,
        caption: "Start antiretroviral therapy plus oral valganciclovir",
      },
      {
        ID: 5094,
        number: 4,
        name: "",
        value: "",
        explain: 0,
        caption:
          "Start intravenous foscarnet and defer antiretroviral therapy for 8 weeks",
      },
    ],
  },
}
